import Parse from 'parse';
import {ClpConstant} from '../security'

const AudioFileClassName = 'Files';
const AlbumClassName = 'Albums';
const ArtistClassName = 'Artists';
const MediaClassName = 'Medias';
const ThumbnailClassName = 'Thumbnails';
const SongTypeClassName = "SongTypes";
const CdLinkClassName = "CdLinks";
const CdLinkCategoryClassName = "CdLinkCategories";
const SongClassName = 'Songs';

const lock = false;


export const albumSchema = {
    title: 'title',
    tracks: 'tracks'
};

export const artistSchema = {
    name: 'name'
};

export const fileSchema = {
    name: 'name',
    file: 'file',
    size: 'size',
    length: 'length'
};

export const mediaSchema = {
    mediaId: 'media_id',
    title: 'title'
};

export const thumbnailSchema = {
    name:'name',
    image:'image'
};
export const cdLinkSchema = {
    name:'name',
    link:'link',
    category:'category'
};

export const cdLinkCategorySchema={
    name:'name'
};

export const songTypeSchema = {
    name:'name'
};

export const songSchema = {
    title: 'title',
    length: 'length',
    type: 'type',
    link: 'cd_links',
    album: 'album',
    file: 'file',
    media: 'media',
    thumbnail: 'thumbnail',
    artist: 'artist'
};


async function createDb(callback) {
    if (lock) return;
    try {
        await createAlbum(callback);
        await createArtist(callback);
        await createFile(callback);
        await createMedia(callback);
        await createThumbnail(callback);
        await createSongType(callback);
        await createCdLinkCategory(callback);
        await createCdLinks(callback);
        await createSong(callback);
    } catch (e) {
        console.log(e);
        callback(null, e.message)
    }
}

async function createAlbum(callback) {
    let album = new Parse.Schema(AlbumClassName);
    album.addString(albumSchema.title, {required: true});
    album.addNumber(albumSchema.tracks, {required: true});
    let clp = ClpConstant.albumClp();
    album.setCLP(clp);
    await album.save();
    callback("Album created")
}

//todo://link song
async function createArtist(callback) {
    let artist = new Parse.Schema(ArtistClassName);
    artist.addString(artistSchema.name, {required: true});
    let clp = ClpConstant.artistClp();
    artist.setCLP(clp);
    await artist.save();
    callback("Artist created")
}

async function createFile(callback) {
    let file = new Parse.Schema(AudioFileClassName);
    file.addString(fileSchema.name, {required: true});
    file.addFile(fileSchema.file, {required: true});
    file.addNumber(fileSchema.size, {required: true});
    file.addNumber(fileSchema.length, {required: true});
    let clp = ClpConstant.fileClp();
    file.setCLP(clp);
    await file.save();
    callback("File Created")
}

async function createMedia(callback) {
    let media = new Parse.Schema(MediaClassName);
    media.addString(mediaSchema.title, {required: true});
    media.addNumber(mediaSchema.mediaId, {required: true});
    let clp = ClpConstant.mediaClp();
    media.setCLP(clp);
    await media.save();
    callback("Media Created");
}

async function createThumbnail(callback){
    let thumbnail = new Parse.Schema(ThumbnailClassName);
    thumbnail.addString(thumbnailSchema.name, {required: true});
    thumbnail.addFile(thumbnailSchema.image, {required: true});
    let clp = ClpConstant.thumbnailClp();
    thumbnail.setCLP(clp);
    await thumbnail.save();
    callback("Thumbnail Created");
}


async function createCdLinkCategory(callback){
    let cdLinkCategory = new Parse.Schema(CdLinkCategoryClassName);
    cdLinkCategory.addString(cdLinkCategorySchema.name, {required: true});
    let clp = ClpConstant.cdLinkCategoryClp();
    cdLinkCategory.setCLP(clp);
    await cdLinkCategory.save();
    callback("Cd links Category Created");
}

async function createCdLinks(callback){
    let cdLink = new Parse.Schema(CdLinkClassName);
    cdLink.addString(cdLinkSchema.name, {required: true});
    cdLink.addString(cdLinkSchema.link, {required: true});
    cdLink.addPointer(cdLinkSchema.category, CdLinkCategoryClassName,{required: true});
    let clp = ClpConstant.cdLinkClp();
    cdLink.setCLP(clp);
    await cdLink.save();
    callback("Cd links Created");
}

async function createSongType(callback){
    let songType = new Parse.Schema(SongTypeClassName);
    songType.addString(songTypeSchema.name, {required: true});
    let clp = ClpConstant.songTypeClp();
    songType.setCLP(clp);
    await songType.save();
    callback("Song Category Created");
}



async function createSong(callback) {
    let song = new Parse.Schema(SongClassName);
    song.addString(songSchema.title, {required: true});
    song.addNumber(songSchema.length, {required: true});

    song.addPointer(songSchema.type, SongTypeClassName);
    song.addArray(songSchema.link, CdLinkClassName);

    song.addPointer(songSchema.thumbnail, ThumbnailClassName);
    song.addPointer(songSchema.album, AlbumClassName);
    song.addPointer(songSchema.file, AudioFileClassName, {required: true});
    song.addPointer(songSchema.media, MediaClassName);
    song.addPointer(songSchema.artist, ArtistClassName);

    let clp = ClpConstant.songClp();
    song.setCLP(clp);
    await song.save();
    callback("Song created")
}


async function deleteAll(callback) {
    try {
        let album = new Parse.Schema(AlbumClassName);
        await album.delete();
        callback("Album Deleted");
        let artist = new Parse.Schema(ArtistClassName);
        await artist.delete();
        callback("Artist Deleted");

        let file = new Parse.Schema(AudioFileClassName);
        await file.delete();
        callback("File Deleted");

        let media = new Parse.Schema(MediaClassName);
        await media.delete();
        callback("Media Deleted");

        let thumbnail = new Parse.Schema(ThumbnailClassName);
        await thumbnail.delete();
        callback("Thumbnail Deleted");

        let songType = new Parse.Schema(SongTypeClassName);
        await songType.delete();
        callback("SongType Deleted");

        let cdLinks = new Parse.Schema(CdLinkClassName);
        await cdLinks.delete();
        callback("CdLinks Deleted");

        let cdLinkCategory = new Parse.Schema(CdLinkCategoryClassName);
        await cdLinkCategory.delete();
        callback("CdLinkCategory Deleted");

        let song = new Parse.Schema(SongClassName);
        await song.delete();
        callback("Song Deleted");

    } catch (ex) {
        console.log(ex);
        callback(null, ex.message);
    }
}

export const ParseDbService = {
    createDb,
    deleteAll,
    AudioFileClassName,
    MediaClassName,
    ArtistClassName,
    AlbumClassName,
    SongClassName,
    SongTypeClassName,
    ThumbnailClassName,
    CdLinkClassName,
    CdLinkCategoryClassName,
};